"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _featuredPresenterBuilder = require("./featuredPresenterBuilder");
Object.keys(_featuredPresenterBuilder).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _featuredPresenterBuilder[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _featuredPresenterBuilder[key];
    }
  });
});